<template>
  <div class="all">
    <div class="header">
      <el-form inline size="small" @submit.native.prevent="getTableData(1)">
        <el-form-item label="时间查询：">
          <el-date-picker v-model="formdata.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" size="small"
            placeholder="选择日期" />
          <span style="vertical-align:top">—</span>
          <el-date-picker v-model="formdata.endTime" type="datetime" size="small" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="search" size="small" placeholder="请输入检索的关键字" prefix-icon="el-icon-search" clearable
            @keyup.native.enter="getTableData(1)" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getTableData(1)">检索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mid">
      <el-table v-loading="loading" :data="comTable" border element-loading-text="数据加载中" height="100%">
        <template slot="empty">
          <img :src="zanwu" alt="">
          <p style="font-size:16px;color:#000;margin-top:36px">暂无数据</p>
        </template>
        <el-table-column type="index" width="80" label="序号" align="center" />
        <el-table-column label="操作用户" min-width="120" prop="name" />
        <el-table-column label="操作时间" min-width="180" prop="createDate" />
        <el-table-column label="操作内容" min-width="200px" show-overflow-tooltip prop="content" />
        <el-table-column label="登录IP" align="left" min-width="200px" prop="ip" />
        <el-table-column label="客户端类型" align="center" min-width="200px" prop="clientType" />
        <el-table-column label="客户端版本号" align="center" min-width="200px" prop="clientVersion" />
      </el-table>
    </div>
    <div class="footer">
      <page :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="getTableData"></page>
    </div>
  </div>
</template>

<script>
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import { mapState } from "vuex";
import page from "@/CommonDP/components/paging";
export default {
  components: { page },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      loading: false,
      value: "",
      formdata: {
        startTime: "",
        endTime: ""
      },
      search: "",
      comTable: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {
    this.getTableData(1);
  },
  methods: {
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getTableData(1);
    },
    async getTableData(index) {
      this.loading = true;
      const {
        search,
        enterpriseId,
        page: { pageSize }
      } = this;
      const params = {
        content: search,
        startTime: this.formdata.startTime,
        endTime: this.formdata.endTime,
        pageSize,
        pageNum: index,
        enterpriseId
      };
      const { data, totalCount, pageNum } = await systemPersonService.pageList(params);
      this.page.totalCount = totalCount;
      this.page.pageNum = pageNum;
      this.comTable = data;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  .mid {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    bottom: calc(32px + var(--middle-space) * 2);
  }
  .footer {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: var(--middle-space) 0;
  }
}
/deep/.el-input--mini .el-input__inner {
  height: 32px;
}
</style>
